export default __webpack_public_path__ + "static/media/Timer.7da8c76e.svg";